// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "../../../../node_modules/rescript/lib/es6/caml.js";
import * as $$Array from "../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_array from "../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as ReactModal from "react-modal";
import * as Button$Catalyst from "../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import ReactSignatureCanvas from "react-signature-canvas";

function checkSignature(pointGroupArray) {
  var sortedPoints = $$Array.map((function (pointer) {
          return pointer.time;
        }), $$Array.concat($$Array.to_list(pointGroupArray)));
  $$Array.sort(Caml.caml_int_compare, sortedPoints);
  var arrLength = sortedPoints.length;
  if (arrLength >= 20) {
    return (Caml_array.get(sortedPoints, arrLength - 1 | 0) - Caml_array.get(sortedPoints, 0) | 0) > 1000;
  } else {
    return false;
  }
}

function handleClear(_event, signatureRef) {
  var inst = signatureRef.current;
  if (!(inst == null)) {
    return Curry._1(inst.clear, undefined);
  }
  
}

function getValidity(signatureRef) {
  var inst = signatureRef.current;
  if (inst == null) {
    return false;
  } else {
    return checkSignature(Curry._1(inst.toData, undefined));
  }
}

function getSignatureImg(_event, signatureRef) {
  var inst = signatureRef.current;
  if (inst == null) {
    return "";
  } else {
    return Curry._2(inst.toDataURL, Curry._1(inst.getCanvas, undefined), undefined);
  }
}

function handleSubmit(dispatch, signatureRef, $$event, onSubmit) {
  var _inst = signatureRef.current;
  if (!(_inst == null)) {
    if (getValidity(signatureRef)) {
      Curry._1(dispatch, /* HideSignatureWarning */3);
      return Curry._1(onSubmit, getSignatureImg($$event, signatureRef));
    } else {
      Curry._1(dispatch, /* ShowSignatureWarning */2);
      handleClear($$event, signatureRef);
      return Curry._1(dispatch, /* SetSubmitUnready */1);
    }
  }
  
}

function reducer(state, action) {
  if (typeof action !== "number") {
    return {
            signatureRef: state.signatureRef,
            signatureImage: action._0,
            submitReady: state.submitReady,
            faultySignature: state.faultySignature
          };
  }
  switch (action) {
    case /* SetSubmitReady */0 :
        return {
                signatureRef: state.signatureRef,
                signatureImage: state.signatureImage,
                submitReady: true,
                faultySignature: state.faultySignature
              };
    case /* SetSubmitUnready */1 :
        return {
                signatureRef: state.signatureRef,
                signatureImage: state.signatureImage,
                submitReady: false,
                faultySignature: state.faultySignature
              };
    case /* ShowSignatureWarning */2 :
        return {
                signatureRef: state.signatureRef,
                signatureImage: state.signatureImage,
                submitReady: state.submitReady,
                faultySignature: true
              };
    case /* HideSignatureWarning */3 :
        return {
                signatureRef: state.signatureRef,
                signatureImage: state.signatureImage,
                submitReady: state.submitReady,
                faultySignature: false
              };
    
  }
}

function TdsFormSignatureModal(Props) {
  var place = Props.place;
  var date = Props.date;
  var onSubmit = Props.onSubmit;
  var onToggle = Props.onToggle;
  var initialState_signatureRef = React.useRef(null);
  var initialState = {
    signatureRef: initialState_signatureRef,
    signatureImage: "",
    submitReady: false,
    faultySignature: false
  };
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  return Curry._1(onToggle, undefined);
                }),
              overlayClassName: "signature-modal__overlay",
              className: "signature-modal__content",
              shouldCloseOnOverlayClick: true,
              children: React.createElement("div", {
                    className: "signature-modal__container"
                  }, React.createElement("div", {
                        className: "signature-modal__close-button",
                        onClick: (function (_event) {
                            return Curry._1(onToggle, undefined);
                          })
                      }, "X"), React.createElement("div", undefined, React.createElement("div", {
                            className: "signature-modal__title"
                          }, "Please sign below"), React.createElement("div", {
                            className: "signature-modal__text"
                          }, "I the declarant do hereby verify that the contracts of the\n                above points are true to the best of my knowledge and\n                belief and no part of it is false and nothing material has\n                been concealed in it."), React.createElement("div", {
                            className: "signature-modal__canvas"
                          }, React.createElement(ReactSignatureCanvas, {
                                onEnd: (function (param) {
                                    return Curry._1(dispatch, /* SetSubmitReady */0);
                                  }),
                                onBegin: (function (param) {
                                    return Curry._1(dispatch, /* HideSignatureWarning */3);
                                  }),
                                canvasProps: {
                                  height: 300,
                                  width: 300,
                                  className: "sign_canvas"
                                },
                                ref: state.signatureRef
                              })), state.faultySignature ? React.createElement("div", {
                              className: "signature-modal__faultySignature"
                            }, "Please provide a valid signature") : null, state.submitReady ? React.createElement("div", {
                              className: "signature-modal__submission"
                            }, React.createElement(Button$Catalyst.make, {
                                  text: "Submit",
                                  cb: (function ($$event) {
                                      return handleSubmit(dispatch, state.signatureRef, $$event, onSubmit);
                                    }),
                                  className: "signature-modal__submitReady signature-modal__button"
                                }), React.createElement(Button$Catalyst.make, {
                                  text: "Clear",
                                  cb: (function ($$event) {
                                      Curry._1(dispatch, /* HideSignatureWarning */3);
                                      handleClear($$event, state.signatureRef);
                                      return Curry._1(dispatch, /* SetSubmitUnready */1);
                                    }),
                                  className: "signature-modal__button signature-modal__cancel"
                                })) : React.createElement("div", undefined, React.createElement("button", {
                                  className: "signature-modal__submitUnready signature-modal__button",
                                  disabled: true
                                }, "Submit")), React.createElement("div", {
                            className: "signature-modal__spaceTime"
                          }, "Date & Place: " + (date + (", " + place)))))
            });
}

var make = TdsFormSignatureModal;

export {
  checkSignature ,
  handleClear ,
  getValidity ,
  getSignatureImg ,
  handleSubmit ,
  reducer ,
  make ,
  
}
/* react Not a pure module */
